import { FC, HTMLAttributes, useState } from 'react';

import { Button, Popover, theme } from 'antd';

import ProfileIcon from 'assets/images/menu/profile.svg?react';
import { UserNav } from 'features/UserNav';
import { useMedia } from 'shared/hooks';

interface IUserInfoProps extends HTMLAttributes<HTMLDivElement> {}

export const UserInfo: FC<IUserInfoProps> = () => {
	const [isOpened, setIsOpened] = useState(false);
	const {
		token: { colorBgBase, colorTextQuaternary },
	} = theme.useToken();
	const isMd = useMedia();

	return (
		<Popover
			open={isOpened}
			onOpenChange={setIsOpened}
			align={{ offset: isMd ? [-10, 10] : [2, 10] }}
			placement={isMd ? 'bottom' : 'bottomLeft'}
			content={<UserNav setIsOpened={setIsOpened} />}
			trigger={'click'}>
			<Button
				color={isOpened ? 'primary' : 'default'}
				variant={isOpened ? 'solid' : 'filled'}
				shape="circle"
				size="small"
				icon={<ProfileIcon />}
				style={{ color: colorBgBase, backgroundColor: isOpened ? undefined : colorTextQuaternary }}
			/>
		</Popover>
	);
};
